import * as React from "react";
import { Stack, Button } from "@mui/material";
import DialogCreateFrom from "../component/DialogCreateForm";
import { useState } from "react";

const SummaryButtons = () => {
  const [visible, setVisible] = useState(false);

  const handleOpenModal = () => {
    setVisible(true);
  };

  const handleCloseModal = () => {
    setVisible(false);
  };

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2}>
      <Button onClick={handleOpenModal} variant="contained">
        Create
      </Button>
      <Button onClick={() => {}} variant="contained">
        Refresh
      </Button>
      <DialogCreateFrom visible={visible} handleClose={handleCloseModal} />
    </Stack>
  );
};

export default SummaryButtons;
